import { screenToStudio } from "@logic/lib/design"
import { useRecoilTransaction_UNSTABLE } from "recoil"

import { nameNode } from "~/containers/LegacyDesigner/utils"

import type { TransactionOperation } from "."
import { readonlyTransactors } from "."
import { tryToAddEdge } from "./addEdge"
import { addNode } from "./addNode"
import { getPreviewNodeSnapPoint } from "./previewEdgeLineLocking"
import { activityState } from "../../activity"
import { zoomState } from "../../view"
import { nodeSelectionState_INTERNAL } from "../nodeSelection"
import { divergeTimeline } from "../timeline/transactions"

export const drawNode: TransactionOperation = (transactors) => {
  const { get } = transactors
  const newNodeId = nameNode()

  const nodeSnapPosition = getPreviewNodeSnapPoint(readonlyTransactors(get))
  const zoom = get(zoomState)
  const studioPoint = screenToStudio.point(nodeSnapPosition.previewNode, zoom)

  const nodeCreation = addNode(transactors, {
    id: newNodeId,
    payload: studioPoint,
  })
  const edgeCreation = tryToAddEdge(transactors, newNodeId)
  const changes = [nodeCreation, edgeCreation]
  divergeTimeline(transactors, changes)
  transactors.set(nodeSelectionState_INTERNAL, new Set([newNodeId]))
}

const tryToDrawNode: TransactionOperation = (transactors) => {
  const activity = transactors.get(activityState)
  const noCurrentActivity = Boolean(activity) === false
  if (noCurrentActivity) drawNode(transactors)
}

export const useTryToDrawNode = (): VoidFunction =>
  useRecoilTransaction_UNSTABLE(
    (transactors) => () => tryToDrawNode(transactors),
  )
